import "./Technicalexp.scss";

const Technicalexp = ({ data }) => {
  const { heading, para, arraydms } = data;

  return (
    <div>
      <div className="technicalexp">
        <h2 className="exp-head">{heading}</h2>
        <div className="subs">
          {arraydms.map((item, index) => (
            <div className="subboxs" key={index}>
              <div className="imgbox">
                 <img  loading="lazy" src={item.src} alt={item.src}   />
              </div>
              <div className="textbox">
                <p dangerouslySetInnerHTML={{ __html: item.desc }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    
    </div>
  );
};

export default Technicalexp;
